<script setup>
import { useCurrency } from '@/composables/useCurrency'
import VehicleStatusPill from '@/Components/UI/VehicleStatusPill.vue'

defineProps({ vehicle: { type: Object, required: true } })
const { formatMoney } = useCurrency()
</script>

<template>
  <div class="flex flex-col">
    <!-- Photo + status ribbon -->
    <div class="relative aspect-[4/3] bg-[color:var(--surfaceAlt)] overflow-hidden">
      <img
        v-if="vehicle.photo_url"
        :src="vehicle.photo_url"
        :alt="`${vehicle.make} ${vehicle.model}`"
        class="w-full h-full object-cover"
      >
      <div
        v-else
        class="w-full h-full flex items-center justify-center"
      >
        <svg
          class="w-12 h-12 text-[color:var(--muted)]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path d="M12 3C7 3 3 7 3 12s4 9 9 9 9-4 9-9-4-9-9-9z" />
          <circle
            cx="6"
            cy="12"
            r="2"
            fill="currentColor"
            stroke="none"
          />
          <circle
            cx="18"
            cy="12"
            r="2"
            fill="currentColor"
            stroke="none"
          />
        </svg>
      </div>
      <div class="absolute top-2 right-2 flex flex-col items-end gap-1">
        <VehicleStatusPill :status="vehicle.status" />
        <span
          v-if="vehicle.currently_sub_rented"
          class="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded-full"
          :style="{ background: 'color-mix(in oklab, var(--warn) 75%, transparent)', color: 'white' }"
        >SUB</span>
      </div>
      <!-- Slot for hover-overlay actions (View/Edit) -->
      <slot name="actions" />
    </div>

    <!-- Info -->
    <div class="p-3">
      <p class="font-medium text-[color:var(--ink)] truncate">
        {{ vehicle.make }} {{ vehicle.model }}
      </p>
      <div class="flex items-center justify-between mt-1">
        <span class="text-xs mono text-[color:var(--muted)]">{{ vehicle.registration }}</span>
        <span class="text-sm fw-value tabular-nums text-[color:var(--accent)]">{{ formatMoney(vehicle.daily_rate_cents) }}/d</span>
      </div>
    </div>
  </div>
</template>
